import { isEmptyArray } from "../../Utils/util";

export default function SelectOption({
  options,
  label,
  onChange,
  value,
  inputRef,
  name,
}) {
  return (
    <>
      <div className="input-effect">
        <select
          className="custom-select"
          onChange={onChange}
          value={value}
          ref={inputRef}
          name={name}
        >
          {/* <option className="custom-option" value={value}>
            {value}
          </option> */}
          <option className="custom-option" value={""}>
            {"select item code"}
          </option>
          {!isEmptyArray(options)
            ? options.map((ln, index) => (
                <option key={index} value={ln} className="custom-option">
                  {ln}
                </option>
              ))
            : null}
        </select>
        <label className="input-effect-label">{label}</label>
        <span className="focus-border"></span>
      </div>
    </>
  );
}
